import superMeta from '../_CATEGORY/metaCategoryNode.mjs'

export default {
    ...superMeta,
    name: '发布者',
    type: 'EVENT_PUBLISHER',
}
